// eslint-disable-next-line
// @ts-nocheck
import { bind } from 'hyperhtml';
import {
	contentTabId,
	getSidebarData,
	updateLockedStatus,
	getFavoriteItemTypes
} from '../NavigationPanel/sidebarDataConverter';
import HeaderTabsContainer from './HeaderTabsContainer';
import {
	cuiBackgroundPage,
	cuiContextMenu,
	CuiLayout,
	cuiMethods,
	cuiToc,
	cuiToolbar
} from 'cui';
import ContextMenu from '../components/contextMenu';
import mainWindowActions from './MainWindowCuiActions';
import { itemType as itemTypeMetadata } from 'metadata';
import { favorites } from 'store';

const tocContextMenuLocation = 'PopupMenuMainWindowTOC';

export default class MainWindowCuiLayout extends CuiLayout {
	_initBackgroundPromise = null;
	_initTocPromise = null;
	backgroundPage = document.getElementById('backgroundPage');
	deferredLocations = ['PopupMenuSecondaryMenu'];
	navigationPanel = document.getElementById('navigationPanel');
	tabsContainer = null;
	actions = mainWindowActions(this.setState.bind(this));
	initialState = {
		splitScreen: {
			dockTabs: [],
			mainTabs: []
		},
		navigationPanel: {
			isVisible: false
		}
	};

	async init() {
		const waitForInit = super.init();
		this.tabsContainer = new HeaderTabsContainer(
			document.getElementById('dock-tab'),
			document.getElementById('main-tab'),
			{
				actions: this.actions
			}
		);

		sessionStorage.setItem('defaultDState', 'defaultDState');

		const commandFactory = cuiMethods.getLayoutCommandFactory(this.options);
		this.options.commandFactory = commandFactory;
		const initHeader = this._initializeHeader();
		const initBackgroundPage = this._initializeBackgroundPage();
		const initToc = this._initializeToc();
		const initContextMenu = this._initializeContextMenu(tocContextMenuLocation);
		const initHeaderTabsContextMenu = this._initializeHeaderTabsContextMenu();
		const headerControl = await initHeader;
		this._registerHeaderHandlers(headerControl);

		await initToc;
		window.selectStartPage();
		this._registerTocHandlers();

		const contextMenu = await initContextMenu;
		this._registerNavPanelHandlers(contextMenu);
		this._setupNavPanel();

		this._registerSidebarHandlers();
		await this._initializeSidebar();

		const headerTabsContextMenu = await initHeaderTabsContextMenu;
		this._registerHeaderTabsContextMenuHandlers(headerTabsContextMenu);

		await initBackgroundPage;
		this._registerBackgroundPageHandlers();
		await waitForInit;
		
		/* TOC 하단에 담당자 표시 - Start */
        let style1 = "font-weight:bold;margin-left:8px;margin-bottom:3px;";
        let style2 = "margin:0px 0px 5px 25px;"
        let addDiv = document.createElement("div");
        addDiv.style.cssText = "width: 90%;border: 1px solid #c5c5c5;margin-left: 10px;border-radius: 7px;";
        
        var pText = document.createElement("p");
        pText.innerHTML = "IT Manager : ";
        pText.style.cssText = style1;
        addDiv.appendChild(pText);
        
        for(var i=1; i<=3; i++) {
            var dat = window.userMessage["ZX_PMS.Info.ITManager" + i];
            
            if (dat) {
                var li = document.createElement("p");
                li.style.cssText = style2;
                li.innerHTML = dat;
                addDiv.appendChild(li);
            }
        }
        
        pText = document.createElement("p");
        pText.innerHTML = "SM : ";
        pText.style.cssText = style1;
        addDiv.appendChild(pText);
        
        for(var i=1; i<=3; i++) {
            var dat = window.userMessage["ZX_PMS.Info.SM" + i];
            
            if (dat) {
                var li = document.createElement("p");
                li.style.cssText = style2;
                li.innerHTML = dat;
                addDiv.appendChild(li);
            }
        }
        addDiv.appendChild(document.createElement("p"));
        this.navigationPanel.nav.appendChild(addDiv);
		/* TOC 하단에 담당자 표시 - End */
	}

	async _getCuiControls() {
		return [
			{
				control_type: 'ShortcutsControl',
				'location@keyed_name': 'MainView.Shortcuts',
				name: 'MainView.Shortcuts'
			}
		];
	}

	updateLayout(oldProps, oldState) {
		this.navigationPanel.setState({ favorites: this.props.favorites });
		this.renderHeader(oldState);
		this._updateBackgroundPage(oldState);
		this.#updateSideBar();
	}

	#updateSideBar() {
		const tabs = this.navigationPanel.tabs;
		const navData = this.navigationPanel.nav.data;
		const favoriteItemTypes = getFavoriteItemTypes(this.props.favorites);
		const sidebarData = getSidebarData(favoriteItemTypes, navData);
		tabs.setState({ favorites: sidebarData });
	}

	renderHeader(oldState) {
		if (oldState.splitScreen !== this.state.splitScreen) {
			const oldSplitScreen = oldState.splitScreen;
			const newSplitScreen = this.state.splitScreen;
			if (
				oldSplitScreen.dockTabs.length + newSplitScreen.dockTabs.length === 1 ||
				oldSplitScreen.mainTabs.length + newSplitScreen.mainTabs.length === 1
			) {
				this.observer.notify('SplitScreen');
			}
		}
		if (oldState.navigationPanel !== this.state.navigationPanel) {
			this.observer.notify('NavigationPanelVisibility');
		}
	}

	async updateCuiLayoutOnItemChange(itemTypeName) {
		const itemType = await itemTypeMetadata.getItemType(
			'CuiDependency',
			'name'
		);
		const morphaes = itemType['Morphae'] ?? [];
		const needToCuiUpgrade = morphaes.some((morphae) => {
			const morphaeName = morphae['related_id@aras.name'];
			return morphaeName === itemTypeName;
		});
		if (needToCuiUpgrade) {
			this.observer.notify('reInitByCUIDependencies');
		}
	}

	mapStateToProps({ favorites }) {
		const filteredFavorites = Object.values(favorites).reduce(
			(acum, favoriteItem) => {
				const { category, quickAccessFlag } = favoriteItem;
				if (
					['ItemType', 'Item'].includes(category) ||
					(category === 'Search' && quickAccessFlag === '1')
				) {
					acum[favoriteItem.id] = favoriteItem;
				}
				return acum;
			},
			{}
		);
		return { favorites: filteredFavorites };
	}

	async _initializeBackgroundPage(options = {}) {
		if (this._initBackgroundPromise) {
			return this._initBackgroundPromise;
		}

		this._initBackgroundPromise = cuiBackgroundPage(
			this.backgroundPage,
			'BackgroundPage',
			{ ...this.options, ...options }
		);
		await this._initBackgroundPromise;
		this._initBackgroundPromise = null;
	}

	_initializeContextMenu(location) {
		return cuiContextMenu(this.navigationPanel.popupMenu, location, {
			...this.options
		});
	}

	_initializeHeaderTabsContextMenu() {
		return cuiContextMenu(new ContextMenu(), 'HeaderTabsContextMenu', {
			...this.options,
			tabs: []
		});
	}

	_registerHeaderTabsContextMenuHandlers(contextMenu) {
		this.tabsContainer.attachContextMenu(contextMenu);
	}

	async _initializeHeader() {
		const toolbarComponent = document.getElementById('headerCommandsBar');
		await cuiToolbar(toolbarComponent, 'MainWindowHeader', this.options);
		toolbarComponent.firstChild.classList.add('aras-header');

		this.options.toggleSplitScreenMode = () =>
			this.tabsContainer.toggleSplitScreenMode();

		return toolbarComponent;
	}

	_initializeSidebar() {
		this.#updateSideBar();
		const tabs = this.navigationPanel.tabs;
		return tabs.selectTab(contentTabId);
	}

	async _initializeToc() {
		if (this._initTocPromise) {
			return this._initTocPromise;
		}

		const nav = this.navigationPanel.nav;
		this._initTocPromise = cuiToc(nav, 'TOC', this.options);

		await this._initTocPromise;
		this._initTocPromise = null;

		return this._initTocPromise;
	}

	_setupNavPanel() {
		const isTocPinned =
			aras.getPreferenceItemProperty(
				'Core_GlobalLayout',
				null,
				'core_toc_pinned'
			) === '1';

		if (isTocPinned) {
			this.navigationPanel.togglePin(true);
			this.navigationPanel.toggleVisibility(true);
		}
	}

	_registerBackgroundPageHandlers() {
		this.observer.subscribe(async (event) => {
			if (event !== 'UpdateTOC') {
				return;
			}

			await this._initializeBackgroundPage();
			this._toggleBackgroundPage(this.state.splitScreen);
		});
	}

	_registerNavPanelHandlers(contextMenu) {
		let activeLocation = tocContextMenuLocation;
		const contextMenus = {
			[activeLocation]: contextMenu
		};
		this.navigationPanel.addEventListener(
			'navigationPanelContextMenu',
			async (event) => {
				const { x, y, location, itemTypeName, itemTypeId, ...detail } =
					event.detail;
				const criteria = itemTypeId
					? [itemTypeId, 'id']
					: [itemTypeName, 'name'];
				const itemTypePromise = itemTypeMetadata.getItemType(...criteria);

				if (activeLocation !== location) {
					activeLocation = location;
					contextMenus[location] = await this._initializeContextMenu(location);
				}

				const itemType = await itemTypePromise;
				const options = {
					...detail,
					favorites,
					itemType,
					itemTypeName: itemType?.name
				};
				contextMenus[location].show({ x, y }, options);
			}
		);
		this.navigationPanel.addEventListener('sidebarPin', (event) => {
			const { state } = event.detail;
			aras.setPreferenceItemProperties('Core_GlobalLayout', null, {
				core_toc_pinned: Number(state)
			});
		});
		this.navigationPanel.addEventListener('sidebarClose', () => {
			this.actions.navigationPanel.updateVisibility(false);
		});
		this.navigationPanel.addEventListener('sidebarShow', () => {
			this.actions.navigationPanel.updateVisibility(true);
		});
	}

	_registerHeaderHandlers(headerControl) {
		this.observer.subscribe((event) => {
			switch (event) {
				case 'reInitByCUIDependencies':
					this._initializeHeader();
					break;
				case 'UpdateNotifications':
				case 'UpdatePreferences':
				case 'SplitScreen':
				case 'NavigationPanelVisibility':
					cuiMethods.reinitControlItems(headerControl, event, this.options);
					break;
			}
		});
		aras.registerEventHandler('PreferenceValueChanged', window, () => {
			this.observer.notify('UpdatePreferences');
		});
	}

	_registerSidebarHandlers() {
		this.observer.subscribe(async (event) => {
			if (event !== 'UpdateTOC') {
				return;
			}

			await this._initializeToc();
			const nav = this.navigationPanel.nav;
			const tabs = this.navigationPanel.tabs;
			updateLockedStatus(tabs.data, nav.data);
			tabs.render();
		});
	}

	_registerTocHandlers() {
		this.observer.subscribe(async (event) => {
			if (event !== 'UpdateTOC') {
				return;
			}

			aras.MetadataCache.DeleteConfigurableUiDatesFromCache();
			await this._initializeToc();
			this.navigationPanel.resetState();
		});
	}

	async _toggleBackgroundPage({ dockTabs, mainTabs }) {
		const hidden = dockTabs.length > 0 || mainTabs.length > 0;
		if (hidden) {
			await this._initBackgroundPromise;
			bind(this.backgroundPage)``;
		} else {
			await this._initializeBackgroundPage({ renderOnly: true });
		}
	}

	_updateBackgroundPage(oldState) {
		const splitScreenState = this.state.splitScreen;
		if (splitScreenState === oldState.splitScreen) {
			return;
		}

		this._toggleBackgroundPage(splitScreenState);
	}
}
